module.exports = __webpack_public_path__ + "img/poucevert_off.c60cbc83.gif";